import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import { defaultTheme } from '../../data/themes';
import Icon from '../icon';

const EMPTY_LIST = Immutable.List([]);

const AccordionWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	padding: ${props => props.theme.accordionPadding || defaultTheme.accordionPadding};
	flex-direction: column;
	background: ${props => props.theme.accordionBackground || defaultTheme.accordionBackground};
	box-shadow: 0 0 20px 0 rgba(0,0,0,0.05);

`;
/*
	.text {
		margin-left: ${props => props.theme.accordionTextMarginLeft || defaultTheme.accordionTextMarginLeft};
	}

*/

const Folder = styled.div`
	position: relative;
	color: ${props => props.theme.accordionHeaderColor || defaultTheme.accordionHeaderColor};
	font-size: ${props => props.theme.accordionHeaderFontSize || defaultTheme.accordionHeaderFontSize};
	font-weight: ${props => props.theme.accordionHeaderFontWeight || defaultTheme.accordionHeaderFontWeight};
	padding-top: ${props => props.theme.accordionHeaderVerticalPadding || defaultTheme.accordionHeaderVerticalPadding};
	padding-bottom: ${props => props.theme.accordionHeaderVerticalPadding || defaultTheme.accordionHeaderVerticalPadding};
	padding-left:${props => props.theme.accordionHeaderLeftPadding || defaultTheme.accordionHeaderLeftPadding};
	&:not(.expanded) {
		border-bottom: ${props => props.theme.accordionFolderSeparator || defaultTheme.accordionFolderSeparator};
	}
	&.expanded {
		color: ${props => props.theme.accordionExpandedHeaderColor || defaultTheme.accordionExpandedHeaderColor};
		font-weight: ${props => props.theme.accordionExpandedHeaderFontWeight || defaultTheme.accordionExpandedHeaderFontWeight};
	}
	&:not(.expanded) {
		cursor:pointer;
		&:hover {
			text-decoration: ${props => props.theme.accordionHoverHeaderTextDecoration || defaultTheme.accordionHoverHeaderTextDecoration};
		}
	}

	> .iconWrapper {
		width: 20px;
		vertical-align: middle;
		display: inline-block;
		text-align: center;
		margin-right: 4px;
		.icon {
			position: relative;
			top: -2px;
		}

	}

	.expansionMarker {
		position: absolute;
		left: 0px;
		top: ${props => props.theme.accordionExpansionMarkerOffset || defaultTheme.accordionExpansionMarkerOffset};;
		width: 2px;
		height: calc( 100% - ${props => props.theme.accordionExpansionMarkerOffset || defaultTheme.accordionExpansionMarkerOffset} );
		background: ${props => props.theme.accordionExpansionMarkerColor || defaultTheme.accordionExpansionMarkerColor};
	}


`;

const ItemContainer = styled.div`
	position: relative;
	//flex-shrink: 1;
	//overflow: auto;
	padding-bottom: ${props => props.theme.accordionExpansionMarkerOffset || defaultTheme.accordionExpansionMarkerOffset};
	border-bottom: ${props => props.theme.accordionFolderSeparator || defaultTheme.accordionFolderSeparator};
`;

const Item = styled.div`
	position: relative;
	color: ${props => props.theme.accordionItemColor || defaultTheme.accordionItemColor};
	font-size: ${props => props.theme.accordionItemFontSize || defaultTheme.accordionItemFontSize};
	font-weight: ${props => props.theme.accordionItemFontWeight || defaultTheme.accordionItemFontWeight};
	padding-left:${props => props.theme.accordionItemLeftPadding || defaultTheme.accordionItemLeftPadding};
	padding-top: ${props => props.theme.accordionItemVerticalPadding || defaultTheme.accordionItemVerticalPadding};
	padding-bottom: ${props => props.theme.accordionItemVerticalPadding || defaultTheme.accordionItemVerticalPadding};
	cursor:pointer;
	&:hover {
		text-decoration: ${props => props.theme.accordionHoverItemTextDecoration || defaultTheme.accordionHoverItemTextDecoration};
	}
	&.selected {
		color: ${props => props.theme.accordionSelectedItemColor || defaultTheme.accordionSelectedItemColor};
		font-weight: ${props => props.theme.accordionSelectedItemFontWeight || defaultTheme.accordionSelectedItemFontWeight};
	}

	.expansionMarker {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 2px;
		height: 100%;
		background: ${props => props.theme.accordionExpansionMarkerColor || defaultTheme.accordionExpansionMarkerColor};
	}


`;

export default class Accordion extends React.PureComponent {

	onItemSelected(folderName, itemName) {
		if (this.props.onItemSelected) {
			this.props.onItemSelected(folderName, itemName);
		}
	}

	onFolderExpanded(folderName) {
		if (this.props.onFolderExpanded) {
			this.props.onFolderExpanded(folderName);
		}
	}

	render() {
		const expandedFolderName = this.props.expandedFolderName;
		const selectedFolderName = this.props.selectedFolderName;
		const selectedItemName = this.props.selectedItemName;
		return (
			<AccordionWrapper className="ps-accordion">
				{
					(this.props.folders || EMPTY_LIST).map((folder, folderIndex) => {
						const folderName = folder.get('name');
						const expanded = folderName === expandedFolderName;
						const selectedFolder = folderName === selectedFolderName;
						return (
							<React.Fragment key={folderIndex}>
								<Folder
									key={folderIndex}
									className={'ps-accordionFolder' + (expanded ? ' expanded' : '')}
									onMouseDown={e => {
										e.preventDefault();
										this.onFolderExpanded(folderName);
									}}
									data-name={folderName}
								>
									{
										expanded && (
											<div className="expansionMarker"/>
										)
									}
									<span className="iconWrapper">
										<Icon
											name={folder.get('icon')}
										/>
									</span>
									<span className="text">{folder.get('text')}</span>
								</Folder>
								{
									expanded && (
										<ItemContainer key={'ic' + folderIndex}>
											{
												(folder.get('items') || EMPTY_LIST).map((item, itemIndex) => {
													const selected = selectedFolder && item.get('name') === selectedItemName;
													return (
														<Item
															key={itemIndex}
															className={'ps-accordionItem' + (selected ? ' selected' : '')}
															onMouseDown={e => {
																e.preventDefault();
																this.onItemSelected(folderName, item.get('name'));
															}}
															data-name={item.get('name')}
														>
															<div className="expansionMarker"/>
															<span className="text">{item.get('text')}</span>
														</Item>
													)
												})
											}
										</ItemContainer>
									)
								}
							</React.Fragment>
						)
					})
				}
			</AccordionWrapper>
		)
	}
}

